export default __webpack_public_path__ + "static/media/eat-this-zombies.f6d15824.jpg";